import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import React from 'react';
import styled from 'styled-components';
import useLocalStorage from '@tools/ui-hooks/useLocalStorage';
import useT from '@tools/ui-hooks/useT';

const CheckBoxStyle = styled(Checkbox)`
  margin-top: 10px;
  margin-left: 8px;
  height: 40px;
  display: inline-flex;
  align-items: center;
`;

const FooterPlatformHub: React.FC<React.PropsWithChildren> = () => {
  const { t } = useT();
  const [isSaveLastLocation, setIsSaveLastLocation] = useLocalStorage('saveLastLocation', true);

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    setIsSaveLastLocation(e.target.checked);
  };

  return (
    <CheckBoxStyle checked={isSaveLastLocation} onChange={handleCheckboxChange}>
      {t('sideContainer.actions.saveLastLocation')}
    </CheckBoxStyle>
  );
};

export default FooterPlatformHub;
